module.exports = __webpack_public_path__ + "img/icn_entrevistapaga_70.5b10670f.svg";